import _ from 'lodash';

import MqttGateway from './lib/mqtt_gateway';

import PhoneControlsActions from 'models/phone_controls_actions';

export default class PhoneControlsGateway extends MqttGateway {
  get version() {
    return '1';
  }

  get topicPattern() {
    return 'customer/+/conversation-items/+/phone-controls';
  }

  addParticipant(customerId, conversationItemId, addAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.ADD,
      parameters: addAttrs,
    });
  }

  blindTransfer(customerId, conversationItemId, transferAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.BLIND_TRANSFER,
      parameters: transferAttrs,
    });
  }

  cancelWarmTransfer(customerId, conversationItemId, transferAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.CANCEL_WARM_TRANSFER,
      parameters: transferAttrs,
    });
  }

  completeWarmTransfer(customerId, conversationItemId, transferAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.COMPLETE_WARM_TRANSFER,
      parameters: transferAttrs,
    });
  }

  initiateWarmTransfer(customerId, conversationItemId, transferAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.INITIATE_WARM_TRANSFER,
      parameters: transferAttrs,
    });
  }

  removeParticipant(customerId, conversationItemId, removeAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.REMOVE,
      parameters: removeAttrs,
    });
  }

  endCall(customerId, conversationItemId) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.END_CALL,
    });
  }

  endConference(customerId, conversationItemId, endConferenceAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.END_CONFERENCE,
      parameters: endConferenceAttrs,
    });
  }

  hold(customerId, conversationItemId, holdAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.HOLD,
      parameters: holdAttrs,
    });
  }

  mute(customerId, conversationItemId, muteAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.MUTE,
      parameters: muteAttrs,
    });
  }

  onUpdateSuccess(payload, topic, parsedTopicParams) {
    const entityId = _.last(parsedTopicParams);
    this.notifyObservers('handlePhoneControlsSuccess', entityId, payload);
  }

  onUpdateErrors(errorDtos, topic, parsedTopicParams) {
    const entityId = _.last(parsedTopicParams);
    this.notifyObservers('handlePhoneControlsErrors', entityId, errorDtos);
  }

  pauseRecording(customerId, conversationItemId, recordingAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.PAUSE_RECORDING,
      parameters: recordingAttrs,
    });
  }

  resumeRecording(customerId, conversationItemId, recordingAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.RESUME_RECORDING,
      parameters: recordingAttrs,
    });
  }

  recordQualityEvent(customerId, conversationItemId, eventAttrs) {
    return super._update([customerId, conversationItemId], {
      action: PhoneControlsActions.RECORD_QUALITY_EVENT,
      parameters: eventAttrs,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/gateways/phone_controls_gateway.js